import { CMSResource } from 'app/resources/cmsresource';
import { ExClientsResource } from './ExClientsResource';
/* tslint:disable */
import { UserResource } from "./UserResource"

export class ExClientsListResource extends CMSResource {
		errorCode: number;
		errorMessage: string;

		list: ExClientsResource[];
}
